<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout row wrap></v-layout>
            </v-card-title>

            <v-card-text class="pt-0">
              <v-form ref="form" 
                v-model="valid" 
                @submit.prevent="createRM"
                lazy-validation
              >
                <v-layout row wrap mt-4>
                  <v-flex xs12 px-3 mb-3>
                    <h4>Personal Details</h4>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>First Name</label>
                      <v-text-field v-model="newRM.first_name" solo type="text" label="First Name"
                        :rules="[v => !!v || 'First name is required']"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>Last Name</label>
                      <v-text-field v-model="newRM.last_name" solo type="text" label="Last Name"
                        :rules="[v => !!v || 'Last name is required']"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>Staff ID</label>
                      <v-text-field v-model="newRM.staff_id" solo type="text" label="Staff ID"
                        :rules="[v => !!v || 'ID number is required']"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>Phone</label>
                      <v-text-field v-model="newRM.phone" solo type="text" label="Phone Number"
                        :rules="[v => !!v || 'Phone number is required']"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>Email</label>
                      <v-text-field
                        v-model="newRM.email" 
                        solo 
                        type="email" 
                        label="Email Address"
                        :rules="emailRules"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider/>
                <v-layout row wrap mt-4>
                  <v-flex xs12 px-3 mb-3>
                    <h4>Security Details</h4>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>Set Password</label>
                      <v-text-field
                        v-model="newRM.password"
                        solo
                        type="password"
                        label="Enter password"
                        :rules="[v => !!v || 'Password is required']"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>Confirm Password</label>
                      <v-text-field
                        v-model="newRM.confirm_password"
                        solo
                        type="password"
                        label="Confirm password"
                        :rules="[v => v === newRM.password || 'Passwords do not match']"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider/>
                <v-layout row wrap mt-4>
                  <!-- <v-flex xs12 px-3 mb-3 align-center>
                    <h4>Assignment Details</h4>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="success"
                      v-if="newRM.merchants[0]"
                      @click="merchantDialog = true"
                    >View Merchants</v-btn>
                  </v-flex> -->
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>State</label>
                      <v-select
                        v-model="newRM.state"
                        solo
                        :items="states"
                        item-text="name"
                        item-value="value"
                        label="Assigned State"
                        :rules="[v => !!v || 'State is required']"
                      ></v-select>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 px-3>
                    <v-layout column>
                      <label class>Route</label>
                      <v-text-field
                        v-model=newRM.routeNumber
                        solo type="text"
                        label="Route"
                        :rules="[v => !!v || 'Route is required']"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex xs12 px-3>
                    <v-layout column>
                      <label class>Select Merchants
                        <v-badge
                          class="top-16"
                          v-if="newRM.merchants[0]"
                          @click.native="merchantDialog = true"
                        >
                          <span slot="badge" v-text="numberOfMerchants"></span>
                        </v-badge>
                      </label>
                      <v-flex>
                        <v-autocomplete
                          solo
                          :items="merchantLocations"
                          item-text="menu"
                          label="Pick Merchants"
                          v-model="selected"
                          @change="addLocation"
                          return-object
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex> -->
                </v-layout>
                <v-card-actions class="pb-5">
                  <v-flex justify-center>
                    <v-btn color="primary" type="submit">Create Marshal</v-btn>
                  </v-flex>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>

          <!-- <v-dialog v-model="merchantDialog" scrollable max-width="550px">
            <v-card>
              <v-card-title>
                <h2 class="font-weight-light secondary--text">Merchants</h2>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="height: 500px">
                <v-list>
                  <v-list-tile
                    v-for="(merchant,index) in newRM.merchants"
                    :key="index"
                    class="mb-2 faint-bg"
                  >
                    <v-layout row wrap fill-height>
                      <v-flex ma-auto pt-1>
                        <v-layout column>
                          <h4 v-text="merchant.merchant_name" class="mb-0"></h4>
                          <h5 v-text="merchant.address" class="font-weight-light"></h5>
                        </v-layout>
                      </v-flex>
                      <div class="d-flex border">
                        <v-btn
                          icon
                          flat
                          color="error"
                          class="no-shadow"
                          @click="deleteItem(merchant,index)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </div>
                    </v-layout>
                  </v-list-tile>
                </v-list>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="justify-center">
                <v-btn color="blue darken-1" flat @click="merchantDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AdminLayout from "../../../layouts/admin"
import { CREATE_ROUTE_MARSHAL } from '@/store/actions/ptspAdmin'
import { FETCH_ROUTES } from '@/store/actions/common'
import { mapState } from "vuex"
import utils from "@/common/utils"

export default {
  name: "CreateMarshal",
  data() {
    return {
      page_title: "New Route Marshal",
      getDate: new Date(),
      merchantDialog: false,
      selected: "",
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      newRM: {
        username: "",
        first_name: "",
        last_name: "",
        password: "",
        confirm_password: "",
        staff_id: "",
        phone: "",
        email: "",
        state: "",
        user_type: 2,
        routeNumber: "",
        // merchants: []
      },
     
    }
  },
  computed: {
    ...mapState({
      routes: state => state.common.routes
    }),
    states: function() {
      return utils.STATE_CHOICES
    },
    
    // merchantLocations: function() {
    //   let temp_location = this.allLocations
    //   temp_location.forEach((element, index) => {
    //     temp_location[index].menu =
    //       element.merchant_name + " - " + element.address
    //   })
    //   return temp_location
    // },
    // numberOfMerchants: function() {
    //   return this.newRM.merchants.length
    // }
  },
  methods: {
    // addLocation(location) {
    //   this.newRM.merchants.push(location)
    //   this.$nextTick(() => {
    //     this.selected = ""
    //   })
    //   this.allLocations.forEach((element, index) => {
    //     if (element.id == location.id) {
    //       this.allLocations.splice(index, 1)
    //     }
    //   })
    // },
    // deleteItem(merchant, index) {
    //   this.newRM.merchants.splice(index, 1)
    //   this.allLocations.push(merchant)
    //   if (!this.newRM.merchants[0]) {
    //     this.merchantDialog = false
    //   }
    // }
    createRM() {
      if (this.$refs.form.validate()) {
        const rep = `${this.newRM.state} ${this.newRM.routeNumber}`
        let route = this.routes.find(route => route.rep == rep)
        this.newRM.route = route.id
        console.log(this.newRM)
      }
      // fetch state
      // this.$store.dispatch(CREATE_ROUTE_MARSHAL, {this.newRM})
    }
  },
  created() {
    this.$emit("update:layout", AdminLayout)
  },
  mounted() {
    this.$store.dispatch(FETCH_ROUTES)
  }
}
</script>

<style scoped>
.top-16 {
  top: -5px
}
.faint-bg {
  background: #fdfdfd
}
</style>


